import { type MapSettingsToolsStateResponse } from '~/map/map.repository';
import { mapSettingsSearchItemsSerializer } from '../searchItems/mapSettingsSearchItems.serializer';
import { mapSettingsToolsStateBoundaryInitialState } from './boundary/mapSettingsToolsStateBoundary.reducer';
import { isDataLayersFilterKey } from './dataLayers/mapSettingsToolsStateDataLayers.helpers';
import type { DataLayersFiltersState } from './dataLayers/mapSettingsToolsStateDataLayers.state';
import { type MapSettingsToolsState } from './mapSettingsToolsState';
import { mapSettingsToolsStateInitialState } from './mapSettingsToolsState.reducer';

export const mapSettingsToolsStateSerializer = {
  jsonToState: (json: MapSettingsToolsStateResponse): MapSettingsToolsState => {
    const { searchItems, ...jsonRest } = json;

    return ({
      ...mapSettingsToolsStateInitialState,
      ...ensureAllBoundaryFilters(jsonRest),
      searchItems: mapSettingsSearchItemsSerializer.jsonToState(searchItems),
      visibility: {
        ...mapSettingsToolsStateInitialState.visibility,
        ...jsonRest.visibility,
      },
      dataLayers: {
        ...mapSettingsToolsStateInitialState.dataLayers,
        ...jsonRest.dataLayers,
        filters: dropIncompatibleDataLayersFilters(jsonRest.dataLayers?.filters),
      },
      activeTool: jsonRest.activeTool ?? mapSettingsToolsStateInitialState.activeTool,
    });
  },
  stateToJson: (state: MapSettingsToolsState): MapSettingsToolsStateResponse => {
    const { searchItems, ...stateRest } = state;

    return ({
      ...stateRest,
      searchItems: mapSettingsSearchItemsSerializer.stateToJson(searchItems),
    });
  },
};

const ensureAllBoundaryFilters = (json: MapSettingsToolsStateResponse): MapSettingsToolsStateResponse => ({
  ...json,
  boundary: {
    filters: json.boundary?.filters || mapSettingsToolsStateBoundaryInitialState.filters,
    locationsFilter: json.boundary?.locationsFilter || mapSettingsToolsStateBoundaryInitialState.locationsFilter,
    activeBTGIdPerBoundaryGroup: json.boundary?.activeBTGIdPerBoundaryGroup || mapSettingsToolsStateBoundaryInitialState.activeBTGIdPerBoundaryGroup,
  },
});

// Filters were previously keyed by boundary group id only; those can't be mapped to a fill, so they are dropped.
const dropIncompatibleDataLayersFilters = (filters: DataLayersFiltersState | undefined): DataLayersFiltersState => Object.fromEntries(
  Object.entries(filters ?? {}).filter(([key]) => isDataLayersFilterKey(key)),
);
